export default [
  {
    path: '/ads-campaign',
    name: 'campaigns',
    component: () => import('@/views/menu/campaign/campaigns.vue'),
    meta: {
      pageTitle: 'کمپین های تبلیغاتی',
      action: 'show',
      resource: 'CampaignManager',
    },
  },
  {
    path: '/ads-channels',
    name: 'channels',
    component: () => import('@/views/menu/campaign/channels.vue'),
    meta: {
      pageTitle: 'کانال های تبلیغاتی',
      action: 'show',
      resource: 'CampaignManager',
    },
  },
  {
    path: '/ads-attributions',
    name: 'attributions',
    component: () => import('@/views/menu/campaign/attribution/attributions.vue'),
    meta: {
      pageTitle: 'اتریبیوشن و ترکرها',
      action: 'show',
      resource: 'CampaignManager',
    },
  },
  {
    path: '/ads-charges',
    name: 'charges',
    component: () => import('@/views/menu/campaign/charge/charges.vue'),
    meta: {
      pageTitle: 'بودجه تبلیغات',
      action: 'show',
      resource: 'CampaignManager',
    },
  },
  {
    path: '/metrix-report',
    name: 'metrixReport',
    component: () => import('@/views/menu/campaign/metrixReport.vue'),
    meta: {
      pageTitle: 'گزارش متریکس',
      action: 'show',
      resource: 'CampaignManager',
    },
  },
  {
    path: '/adtrace-report',
    name: 'adtraceReport',
    component: () => import('@/views/menu/campaign/adtraceReport.vue'),
    meta: {
      pageTitle: 'گزارش ادتریس',
      action: 'show',
      resource: 'CampaignManager',
    },
  },
  {
    path: '/tracker-report',
    name: 'trackerReport',
    component: () => import('@/views/menu/campaign/trackerReport.vue'),
    meta: {
      pageTitle: 'گزارش ترکر',
      action: 'show',
      resource: 'CampaignManager',
    },
  }
]